import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import InstructionVideoForm from './InstructionVideoForm';
import InstructionVideoFormService from '../services/InstructionVideoFormService';

class InstructionVideoFormContainer extends React.Component {
  static propTypes = {
    instructionVideoId: PropTypes.string,
  };

  static defaultProps = {
    instructionVideoId: null,
  };

  componentDidMount() {
    InstructionVideoFormService.handleLoad(this.props.instructionVideoId);
  }

  render() {
    return (
      <InstructionVideoForm
        onChange={InstructionVideoFormService.form.setValue}
        onSubmit={InstructionVideoFormService.handleSubmit}
        onReset={InstructionVideoFormService.form.reset}
        onDelete={InstructionVideoFormService.handleDelete}
        onEdit={InstructionVideoFormService.handleEdit}
        values={InstructionVideoFormService.form.getValues()}
        loading={InstructionVideoFormService.fetch.fetching}
        submitting={InstructionVideoFormService.submit.fetching}
        errors={InstructionVideoFormService.form.errors}
      />
    );
  }
}

export default observer(InstructionVideoFormContainer);
